import handle from "./Axios"
import * as qs from 'query-string'

const getList = (key: string) => {
  try {
    return handle.get(key)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

const getChainList = ([url, symbol]: [string, string]) => {
  const str = qs.stringify({ symbol })

  try {
    return handle.get(url + '?' + str).then(res => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

const getWallet = ([url, network]: [string, string]) => {
  try {
    return handle.post(url, { network }).then(res => res.data.data)
  } catch (error: any) {
    const { response, message } = error
    if (response) {
      return response
    }
    return message
  }
}

export default { getList, getChainList, getWallet }
